import withFallbackReportData from '../util/withFallbackReportData'
import { ky } from './client'

export async function getCompliance(auditId) {
  try {
    return await ky
      .get('compliance/' + auditId, {
        customErrorMessage: 'Unable to get compliance for this audit',
        showErrorToast: true
      })
      .json()
  } catch (error) {
    return {
      denominator: 0,
      nominator: 0,
      percentage: 0
    }
  }
}

export async function getComplianceSummary({ from, to, viewAll, section, filters, onlyOverAllGrade }) {
  return await withFallbackReportData(({ toast }) =>
    ky
      .get('compliance/summary', {
        searchParams: {
          ...(from ? { from } : {}),
          ...(to ? { to } : {}),
          ...(viewAll ? { viewAll } : {}),
          ...(section ? { section } : {}),
          ...(filters ? { filters: JSON.stringify(filters) } : {}),
          onlyOverAllGrade: onlyOverAllGrade ?? false
        },
        ...toast('Fully compliant sections')
      })
      .json()
  )
}

export async function getComplianceStackedArea() {
  return await withFallbackReportData(({ toast }) => ky.get('compliance/stacked-area', toast('Fully compliant audits')).json())
}

export async function getComplianceSummaryCSV({ from, to, viewAll, section, filters }) {
  const response = await ky
    .get('compliance/summary-csv', {
      searchParams: {
        ...(from ? { from } : {}),
        ...(to ? { to } : {}),
        ...(viewAll ? { viewAll } : {}),
        ...(section ? { section } : {}),
        ...(filters ? { filters: JSON.stringify(filters) } : {})
      },
      timeout: 30000
    })
    .blob()

  const url = window.URL.createObjectURL(response)

  const link = document.createElement('a')
  link.href = url

  link.setAttribute('download', `Compliance_Summary_${new Date().getTime()}.csv`)

  document.body.appendChild(link)
  link.click()

  link.parentNode.removeChild(link)
  window.URL.revokeObjectURL(url)

  return response
}
